export function splitAmount(value: number) {
  const arrayAmount = Math.abs(value).toFixed(2).toString().split(".");
  if (arrayAmount.length > 1) return [arrayAmount[0], formatDecimal(arrayAmount[1])];
  return [arrayAmount[0], ".00"];
}

function formatDecimal(decimal: string) {
  if (decimal.length === 1) return `.0${decimal}`;

  if (decimal.length === 0) return ".00";

  return `.${decimal}`;
}

export function getPriceSizeClass(size: string) {
  switch (size) {
    case "large":
      return "price--amount-large";
    case "medium":
      return "price--amount";
    case "small":
      return "price--amount";
    case "xsmall":
      return "price--amount-xsmall";
    default:
      return "price--amount";
  }
}
